<script>
    export let name;
    export let hasComments = false;
    export let cancelHandler;
    export let confirmHandler;
    export let actionName;
</script>

<div class="dialog">
    <p class="dialog-title">
        Are you sure you want to {actionName.toLowerCase()}
        <span class="dialog-name">"{name}"</span>
        <b class="small-text">Snippet</b>
        {#if hasComments}
            <span class="small-text"
                >and all it's <b class="small-text">Comments</b></span
            >
        {/if}
    </p>
    <footer class="dialog-footer">
        <button class="dialog-btn" on:click={cancelHandler}> Cancel</button>
        <button class="dialog-btn dialog-btn--red" on:click={confirmHandler}>
            {actionName}
        </button>
    </footer>
</div>

<style>
    @import "../main.css";

    .dialog {
        @apply reset absolute bottom-0 left-0 z-20 flex h-full w-full flex-col rounded-xl bg-pink-100 !important;
    }

    .dialog-title {
        @apply reset sticky top-0 px-4 pt-4 text-sm !important;
    }

    .small-text {
        @apply text-xs !important;
    }

    .dialog-title .dialog-name {
        @apply my-2 block border-0 border-l border-solid border-pink-600 py-1 pl-2 !important;
    }

    .dialog-footer {
        @apply mt-auto flex select-none justify-end bg-transparent px-2 pb-2 pt-1 !important;
    }

    .dialog-btn {
        @apply reset rounded-sm border-none px-2 py-1 text-xs font-normal text-black no-underline hover:bg-pink-200 focus:outline-none !important;
    }

    .dialog-btn--red {
        @apply font-bold text-pink-500 hover:bg-pink-200 !important;
    }
</style>
